export default __webpack_public_path__ + "static/media/V860_RoHS.cfcd35ce.pdf";